"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSize = exports.Avatar = void 0;

var tslib_1 = require("tslib");

var ui_symbols_1 = require("@hopin-team/ui-symbols");

var react_1 = tslib_1.__importDefault(require("react"));

var styled_components_1 = tslib_1.__importDefault(require("styled-components"));

var getSize = function getSize(_a) {
  var size = _a.size,
      scale = _a.scale;

  if (scale) {
    return ui_symbols_1.calcSpace(scale);
  }

  switch (size) {
    case 'tiny':
      return 'var(--avatar-size-tiny)';

    case 'medium':
      return 'var(--avatar-size-medium)';

    case 'large':
      return 'var(--avatar-size-large)';

    case 'huge':
      return 'var(--avatar-size-huge)';

    case 'gigantic':
      return 'var(--avatar-size-gigantic)';

    case 'small':
    default:
      return 'var(--avatar-size-small)';
  }
};

exports.getSize = getSize;
var StyledAvatar = styled_components_1.default.img(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  border-radius: 50%;\n  object-fit: cover;\n  height: ", ";\n  width: ", ";\n"], ["\n  border-radius: 50%;\n  object-fit: cover;\n  height: ", ";\n  width: ", ";\n"])), function (_a) {
  var size = _a.size,
      scale = _a.scale;
  return getSize({
    size: size,
    scale: scale
  });
}, function (_a) {
  var size = _a.size,
      scale = _a.scale;
  return getSize({
    size: size,
    scale: scale
  });
});

var Avatar = function Avatar(_a) {
  var alt = _a.alt,
      _b = _a.size,
      size = _b === void 0 ? 'small' : _b,
      props = tslib_1.__rest(_a, ["alt", "size"]);

  return react_1.default.createElement(StyledAvatar, tslib_1.__assign({
    alt: alt,
    size: size
  }, props));
};

exports.Avatar = Avatar;
var templateObject_1;